import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders,HttpParams } from '@angular/common/http';


import { Observable, of, throwError } from 'rxjs';
import { catchError, last, map, tap } from 'rxjs/operators';

// URL to web api
const baseApiUrl = '';
const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
}

@Injectable({
  providedIn: 'root'
})
export class ActivePlanListService {
  constructor(private http: HttpClient) {}

  getActivePlanList(custId : any): Observable<any> {
    const get_url = baseApiUrl + 'subscriber/getActivePlanList/' + custId;
    return this.http.get<any>(get_url,
      { headers: httpOptions.headers }).pipe(
        map(res => res),
        catchError((error: any) => {
          return throwError(error);
        })
      );
  }

  //Listing of Approve Plan

  getPlanListForActivation(params:any): Observable<any> {
    const get_url = baseApiUrl + 'customerPurchase/purchaseList';
    return this.http.post<any>(get_url,params,
      { headers: httpOptions.headers }).pipe(
        map(res => res),
        catchError((error: any) => {
          return throwError(error);
        })
      );
  }
  // perform Action on Button
  getcustomerPurchaseAction(params:any): Observable<any> {
    const get_url = baseApiUrl + 'customerPurchase/performAction';
    return this.http.post<any>(get_url,params,
      { headers: httpOptions.headers }).pipe(
        map(res => res),
        catchError((error: any) => {
          return throwError(error);
        })
      );
  }

}